import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { RosaRequiredEquipment } from '@/types/entities/Rosa';

type EquipmentRequest = {
	id?: string;
	name?: string;
	priority: number;
	action: 'MAINTENANCE' | 'CHANGE' | 'PROVIDE';
};

type CreateRequiredEquipmentsRequest = {
	report_id: string;
	company_id: string;
	organization_id: string;
	equipments: EquipmentRequest[];
};

type CreateRequiredEquipmentsResponse = Omit<RosaRequiredEquipment, 'deleted_at'>;

async function createRequiredEquipments(
	params: CreateRequiredEquipmentsRequest
): Promise<CreateRequiredEquipmentsResponse[]> {
	const url = `/ergonomic-tool/rosa/equipments/${params.report_id}`;
	const { data } = await Api.put(url, params);
	return data;
}

export const useCreateRequiredEquipment = () => {
	const queryClient = useQueryClient();
	return useMutation<CreateRequiredEquipmentsResponse[], any, CreateRequiredEquipmentsRequest>(
		(payload) => createRequiredEquipments(payload),
		{
			onSuccess: () => {
				queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_REQUIRED_EQUIPMENTS]);
			},
			onError: () => {
				message.error(I18n.get('Failed to create elements'));
			}
		}
	);
};
